module.exports = __webpack_public_path__ + "img/apple-iphone-1@2x.a69b9823.png";